<template>
    <div class="main-bottom">
    <!--  <div class="bottom-list">
        <div >
          <div>集团介绍</div>
          <div>新闻资讯</div>
          <div>业务体系</div>
          <div>党群园地</div>
          <div>车辆监控</div>
          <div>快速链接</div>
        </div>
        <div>
          <div>集团简介</div>
          <div>公司要闻</div>
          <div>客运服务</div>
          <div>党建动态</div>
          <div>国脉新监控平台</div>
          <div>依畅购票官网</div>
        </div>
        <div>
          <div>企业荣誉</div>
          <div>公司公告</div>
          <div>货运服务</div>
          <div>工会动态</div>
          <div>国脉旧监控平台</div>
          <div>湖南定制客运官网</div>
        </div>
        <div>
          <div>企业文化</div>
          <div>基层动态</div>
          <div>广告业务</div>
          <div>衡汽集团报</div>
          <div>赛格监控平台</div>
          <div></div>
        </div>
        <div>
          <div>组织架构</div>
          <div>政策法规</div>
          <div>维修业务</div>
          <div></div>
          <div></div>
          <div></div>
        </div>
        <div>
          <div>领导分工</div>
          <div>春运专栏</div>
          <div>安全在线</div>
          <div></div>
          <div></div>
          <div></div>
        </div>
        <div>
          <div></div>
          <div></div>
          <div>公交出租</div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>-->
      <div class="bottom-company">
        <div>湖南省衡阳汽车运输集团有限公司</div>
        <div>欢迎致电　0734-8856338</div>
        <div></div>
      </div>
      <div class="copyright">版权所有:湖南省衡阳汽车运输集团有限公司 Copyright©{{new Date().getFullYear()}} All Right Reseved　　备案号:湘ICP备07011026号-1</div>
    </div>
</template>

<script>
    export default {
        name: "main-bottom"
    }
</script>

<style scoped>
  .main-bottom{
    background-color: rgb(47,48,52);
    color: white;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    white-space:nowrap;
    /*height: 620px;*/
    height: 280px;
  }
  .copyright{
    margin: 22px;
    font-size: 17px;
  }
  .bottom-company{
    height: 150px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 80%;
    border-bottom: #8a8a8a solid 1px
  }
  .bottom-company >div:nth-child(1){
    font-size: 30px;
    margin: 10px;
  }
  .bottom-company >div:nth-child(2){
    font-size: 20px;
    margin: 10px;
  }

  .bottom-list{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 80%;
    margin-top: 50px;
    height: 400px;
  }

  .bottom-list > div{
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin: 5px 30px;
    width: 100%
  }

  .bottom-list > div > div{
    margin: 10px 30px;
    flex : 1;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/views/main-bottom.vue